import _ from 'lodash';

import { checkGrupTemperaturaHumitatEvaporacio } from './grupTemperaturaHumitatEvaporacio';
import { checkGrupVent } from './grupVent';
import { checkGrupPressioAtmosferica } from './grupPressioAtmosferica';
import { checkGrupInsolacio } from './grupInsolacio';
import { checkGrupPrecipitacio } from './grupPrecipitacio';
import { checkGrupsTempsPresentIVisibilitatINeu } from './grupsTempsPresentIVisibilitatINeu';
import { checkGrupTempsPassatINeu } from './grupsTempsPassatINeu';
import { checkGrupCel } from './grupCel';
import { checkFiltresRang } from './filtresRang';

/*
* Funció auxiliar que donat un llistat de variables de tipus grup/variables crea una nova còpia i, a més, inicialitza l'array d 'errors'
* IMPORTANT. Donat que es fa una nova còpia i aquest és el primer mètode que s'executa, ja no ens em d'amoïnar de la immutabilitat de Redux.
* Es fan exportables per realitzar els tests i treballar amb TDD
***/
const inicialitzaErrorsDeVariables = (variables) => {
    // Fem una còpia de les variables
    let nouVariables = _.cloneDeep(variables);

    Object.keys(nouVariables).forEach((nomGrup) => {
        nouVariables[nomGrup].forEach(variable => variable.errors = []);
    });

    return nouVariables;
};

/*
 * Calcula els diferents errors de coherència de les diferents variables.
 * Retorna una còpia del mateix formulari i si una variable conté errors s'afegeix un array amb el llistat d'errors.
 * Es fan exportables per realitzar a que s'utilitzi a variables.js. Els tests es provaran directament a aquest reducer.
 ***/
export const calculaErrorsCoherencia = (variables) => {

    /*
     * Còpia del llistat grup/variables original.
     * És el que es retornarà finalment i és modificable a nivell de grup i d'array de variables per preservar la immutabilitat.
     ***/
    let nouVariables = inicialitzaErrorsDeVariables(variables);

    // Processa els diferents grups
    checkGrupTemperaturaHumitatEvaporacio(nouVariables);
    checkGrupVent(nouVariables);
    checkGrupPressioAtmosferica(nouVariables);
    checkGrupInsolacio(nouVariables);
    checkGrupPrecipitacio(nouVariables);
    checkGrupsTempsPresentIVisibilitatINeu(nouVariables);
    checkGrupTempsPassatINeu(nouVariables);
    checkGrupCel(nouVariables);

    checkFiltresRang(nouVariables);

    return nouVariables;
};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/index.js